import React from "react";
import { Tabs, TabList, TabPanels, Tab, TabPanel, Box } from "@chakra-ui/react";
import TicketTable from "./TicketTable";

const TicketStatusTabs = ({ tickets, handleImagePreview, confirmStatusChange, ticketStatuses, getShareableLink }) => {
    return (
        <Tabs variant="solid-rounded" colorScheme="brand" isLazy>
            <Box
                overflowX="auto"
                whiteSpace="nowrap"
                css={{
                    "&::-webkit-scrollbar": { display: "none" },
                    "msOverflowStyle": "none", 
                    "scrollbarWidth": "none",
                }}
            >
                <TabList pl={4} display="flex" flexWrap="nowrap">
                    {ticketStatuses.map((tab) => (
                        <Tab flexShrink={0} px={4} fontSize="sm" textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">{tab.name}</Tab>
                    ))}
                </TabList>
            </Box>

            <TabPanels>
                {ticketStatuses?.map(status => (
                    <TabPanel key={status.code}>
                        <TicketTable
                            tickets={tickets}
                            status={status.code}
                            handleImagePreview={handleImagePreview}
                            confirmStatusChange={confirmStatusChange}
                            getShareableLink={getShareableLink}
                        />
                    </TabPanel>
                )) || null}
            </TabPanels>
        </Tabs>
    );
};

export default React.memo(TicketStatusTabs);